import type { Feedback, SendFeedbackPayload } from '../../types/index.js';
import { baseApi } from '../base-api.js';

type FeedbackResponse = { feedback: Feedback; message: string };
type FeedbackByIdResponse = { feedback: Feedback };

/**
 * Mirrors `apps/server/src/modules/feedback` (`feedbackController`). The server only exposes
 * create (any authenticated user) and get-by-id (admin only) — there is no list route, so there
 * is no `LIST` tag to invalidate on send, only the individual `feedback_id` once it's known.
 */
export const feedbackApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    sendFeedback: builder.mutation<Feedback, SendFeedbackPayload>({
      query: (body) => ({ path: ['feedbacks'], method: 'post', body }),
      transformResponse: (response: FeedbackResponse) => response.feedback,
    }),

    getFeedbackById: builder.query<Feedback, string>({
      query: (id) => ({ path: ['feedbacks', { param: 'feedback_id', value: id }], method: 'get' }),
      transformResponse: (response: FeedbackByIdResponse) => response.feedback,
      providesTags: (_result, _error, id) => [{ type: 'Feedback', id }],
    }),
  }),
});

export const { useSendFeedbackMutation, useGetFeedbackByIdQuery } = feedbackApi;
